import benchmark from './benchmark';
import config from './config';
import dashboard from './dashboard';
import issues from './issues';
import keyvalue from './key-value';
import learning from './learning';
import log from './log';
import faqReport from './faq-report';
import promotionTrackingReport from './promotion-tracking-report';
import model from './model';
import persist from './persist';
import promotion from './promotion';
import rulebase from './rulebase';
import storyboard from './storyboard';
import testset from './test-set';
import train from './train';
import understanding from './understanding';
import usermanager from './user-manager';
import nlpconfig from './nlp-config';
import satisfaction from './satisfaction';
import nps from './nps';
import knowledgeFile from './knowledge-file';
import lineBroadcast from './line-broadcast';

export default {
  benchmark,
  config,
  dashboard,
  issues,
  keyvalue,
  learning,
  log,
  faqReport,
  promotionTrackingReport,
  model,
  persist,
  promotion,
  rulebase,
  storyboard,
  testset,
  train,
  understanding,
  usermanager,
  nlpconfig,
  satisfaction,
  nps,
  knowledgeFile,
  lineBroadcast,
};
